import React from 'react';
import {Text} from '@forecast-it/design-system';

type DateInvalidErrorProps = {
	dateError?: string | null;
	textSize?: '1' | '2';
	marginTop?: string;
	marginBottom?: string;
};
export function DateInvalidError({dateError, textSize, marginTop, marginBottom}: DateInvalidErrorProps): JSX.Element | null {
	return dateError ? (
		<div style={{marginTop: marginTop || '8px', marginBottom: marginBottom || '4px'}}>
			<Text size={textSize || '2'} color={'error'}>
				{dateError}
			</Text>
		</div>
	) : null;
}
